"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportPrivateKeyWithLitAction = void 0;
const utils_1 = require("./utils");
const constants_1 = require("@lit-protocol/constants");
async function exportPrivateKeyWithLitAction(args) {
    const { accessControlConditions, litNodeClient, pkpSessionSigs, litActionCode, litActionIpfsCid, storedKeyMetadata, } = args;
    const { pkpAddress, ciphertext, dataToEncryptHash, ...storeKeyMetadataMinusEncryptedAndPkp } = storedKeyMetadata;
    const result = await litNodeClient.executeJs({
        sessionSigs: pkpSessionSigs,
        code: litActionCode,
        ipfsId: litActionIpfsCid,
        jsParams: {
            pkpAddress,
            ciphertext,
            dataToEncryptHash,
            accessControlConditions,
        },
        ipfsOptions: {
            overwriteCode: constants_1.GLOBAL_OVERWRITE_IPFS_CODE_BY_NETWORK[litNodeClient.config.litNetwork],
        },
    });
    const decryptedPrivateKey = (0, utils_1.postLitActionValidation)(result);
    return {
        decryptedPrivateKey,
        pkpAddress,
        ...storeKeyMetadataMinusEncryptedAndPkp,
    };
}
exports.exportPrivateKeyWithLitAction = exportPrivateKeyWithLitAction;
//# sourceMappingURL=export-private-key.js.map